import { render, staticRenderFns } from "./DocCards.vue?vue&type=template&id=627cd980&scoped=true&"
import script from "./DocCards.vue?vue&type=script&lang=js&"
export * from "./DocCards.vue?vue&type=script&lang=js&"
import style0 from "./DocCards.vue?vue&type=style&index=0&id=627cd980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cd980",
  null
  
)

export default component.exports